import Box from '@liquidweb-dev/undercurrent/Box';
import ListItem, {
	type ListItemProps,
} from '@liquidweb-dev/undercurrent/ListItem';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const SkeletonListItem = ({ sx, ...rest }: ListItemProps) => (
	<ListItem
		sx={combineSx({ padding: 200, gap: 300, alignItems: 'center' }, sx)}
		{...rest}
	>
		<Box sx={{ display: 'flex', gap: 200, alignItems: 'center' }}>
			<Skeleton
				variant="circular"
				sx={({ size }) => ({ width: size.md, height: size.md })}
			/>

			<Stack sx={{ gap: 100 }}>
				<Skeleton
					variant="rounded"
					sx={{ width: '250px', height: ({ size }) => size.xXS }}
				/>
				<Skeleton
					variant="rounded"
					sx={{ width: '200px', height: ({ size }) => size.xXS }}
				/>
			</Stack>
		</Box>

		<Skeleton
			variant="rounded"
			sx={{ flex: '1 0 0', height: ({ size }) => size.xXS }}
		/>

		<Skeleton
			variant="rounded"
			sx={{ width: '87px', height: ({ size }) => size.xXS }}
		/>
	</ListItem>
);

export default SkeletonListItem;
